export default {
  ZENDESK_URL: 'https://bluecargo.zendesk.com/hc/en-us',
  BUGSNAG_API_KEY: '357b688873ac90c21fc27c41ef99d85b',
  DATA_GRID_PRO_LICENSE_KEY:
    'de6828cebc38ac29b9b84717b773642bTz01MDgwOCxFPTE2OTQ3MzE4ODY0NjcsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
  DATADOG_CLIENT_TOKEN: 'pub05c9e5605a929975c462fd632c77cbd1',
};
